import { HttpClient } from '@angular/common/http';
import { ConfigService } from './core/config.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
var ɵ0 = {
    customSeoRetrieval: true
}, ɵ1 = function (config) { return function () {
    return config.load().then(function (result) {
        return result;
    }).catch(function (err) {
        return err;
    });
}; }, ɵ2 = [
    'siteId', 'path'
], ɵ3 = {
    URL: '/wdpr-web-dcl-homepage/geocode/',
    COOKIE_AKA: 'geolocation_aka_jar',
    COOKIE_JAR: 'GEOLOCATION_jar',
    ISO_COUNTRY_MAP: {
        'US': 'united+states',
        'CA': 'canada',
        'AR': 'argentina',
        'MX': 'mexico',
        'GB': 'united+kingdom',
        'PE': 'peru',
        'CO': 'colombia',
        'CL': 'chile',
        'BR': 'brazil'
    },
    REGION_MAP: {
        'CA': 'california',
        'FL': 'florida'
    }
};
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http, '/wdpr-web-dcl-homepage/i18n/', '.json');
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
